import { PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

import { usePageUrl } from '../../../../../../lib/pages'
import Link from '../../../../../global/Link'

import alertIcon from '../../../../../../img/account_document_upload_icons/error-icon.svg'

const StyledMissingAccountInformation = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  padding: 25px;
`

const StyledTitle = styled.h5`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 0;
`

const StyledAlertIcon = styled.img`
  height: 16px;
  width: 16px;
  margin-right: 8px;
`

const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-weight: 400;
    font-size: 1rem;
    line-height: 20px;
  }
`

const StyledHeading = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 32px;
`

const StyledCommissionsButton = styled(SecondaryButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  color: ${({ theme }) => theme.colors.semantic.error};
  border: 1px solid ${({ theme }) => theme.colors.semantic.error};
  max-width: 322px;
  border-radius: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  flex: auto;
  &:hover {
    background-color: ${({ theme }) => theme.colors.semantic.error};
  }
`

const StyledSubmitButton = styled(PrimaryButton)`
  max-width: 322px;
  border-radius: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  flex: auto;
`

const StyledButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
`

export interface MissingAccountInformationMessageProps {
  className?: string
}

export const MissingAccountInformationMessage: React.FC<MissingAccountInformationMessageProps> = ({
  className,
}) => {
  const { navigate } = usePageUrl()
  return (
    <div className={className}>
      <StyledMissingAccountInformation>
        <StyledHeading>
          <StyledAlertIcon src={alertIcon} />
          <StyledTitle>Missing Account Information</StyledTitle>
        </StyledHeading>
        <StyledDescription>
          Your dispensary is not currently earning you any commissions. To start earning
          commissions, ACH and W-9 details are required. Submit Account Documents
        </StyledDescription>
        <StyledButtonsContainer>
          <StyledCommissionsButton as={Link} to="/account/settings/rewards-program">
            Opt Out of Commissions
          </StyledCommissionsButton>
          <StyledSubmitButton onClick={() => navigate('/account/settings/documents')}>
            Submit Account Documents
          </StyledSubmitButton>
        </StyledButtonsContainer>
      </StyledMissingAccountInformation>
    </div>
  )
}
